import { ClientLogRequest } from '@1po/1po-bff-fe-spec/generated/client_log/request/ClientLogRequest';
import { PUT_CLIENT_LOG } from '@1po/1po-bff-fe-spec/generated/common/WebsocketConstants';
import { WebSocketAction } from 'utils/domainStore';
import { wsSendAction } from 'utils/domainStore/api';

export function sendClientLogRequest(clientLogRequest: ClientLogRequest): WebSocketAction {
  return wsSendAction(PUT_CLIENT_LOG, clientLogRequest);
}
